import type { JSX } from "react";
import PulseIcon from "../../shared/components/icons/taskIcons/PulseIcon";
import t from "../../shared/translations";
import { FinishedBox } from "./stylings";

function Finished(): JSX.Element {
    return (
        <FinishedBox>
            <PulseIcon active />
            <h2>{t("public.pulse.heading-finished")}</h2>
        </FinishedBox>
    );
}

export default Finished;
